<template>
    <div v-if="info && canShow('健康平衡度') && info.tizhi_content && info.tizhi_content.tongue_score">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">健康平衡度</div>
        </div>
        <div class="assessment no-text">
            <div id="main" class="balance-meter"></div>
            <div class="condition" v-if="info.tizhi_content.tongue_score == 1">
                可能患有疾病，建议<span class="orange">就医检查</span>
            </div>
            <div class="condition" v-if="info.tizhi_content.tongue_score == 2">
                身体极不平衡，建议<span class="orange">马上调理</span>
            </div>
            <div class="condition" v-if="info.tizhi_content.tongue_score == 3">
                身体较不平衡，建议<span class="orange">马上调理</span>
            </div>
            <div class="condition" v-if="info.tizhi_content.tongue_score == 4">
                身体较为平衡，建议<span class="green">适当调理</span>
            </div>
            <div class="condition" v-if="info.tizhi_content.tongue_score == 5">
                身体平衡，建议<span class="green">适当调理</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin } from '../helpers';
import { drawMeter } from '../chart';

const METER_COLOR = [
    [0.2, '#F36440'],
    [0.4, '#F89143'],
    [0.6, '#ECDB44'],
    [0.8, '#5CC7BC'],
    [1, '#83D186']
];

// page===0 是整页显示，page===7 是单独翻到健康平衡度这一屏
// 仅在这两种情况下 y7 容器才是 display:block，仪表盘才能正确绘制
const VISIBLE_PAGES = [0, 7];

export default {
    name: 'ReportBalance',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info', 'page']),
        tongueScore() {
            return this.info && this.info.tizhi_content && this.info.tizhi_content.tongue_score;
        },
        meterVisible() {
            return VISIBLE_PAGES.indexOf(this.page) !== -1;
        }
    },
    mounted() {
        this.scheduleRenderMeter();
    },
    watch: {
        meterVisible(val) {
            if (val) this.scheduleRenderMeter();
        },
        tongueScore() {
            this.scheduleRenderMeter();
        }
    },
    methods: {
        scheduleRenderMeter() {
            if (!this.meterVisible) return;
            setTimeout(() => this.renderMeter(), 1);
        },
        renderMeter() {
            if (!this.info) return;
            if (!this.tongueScore) return;
            if (!this.canShow('健康平衡度')) return;
            drawMeter('main', {
                color: METER_COLOR,
                score: this.tongueScore * 20 - 10
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import './Balance.scss';
</style>
